import { t } from "./i18n.js"

const DEFAULT_ERROR = () => t("checkout_error_default", "We couldn't start checkout. Please try again.")

export async function startCampaignCheckout({ campaignId, csrfToken, fetchRequest = fetch, navigate, onError }) {
  try {
    const response = await fetchRequest("/api/stripe/checkout_campaign", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ reading_campaign_id: campaignId })
    })
    const data = await response.json().catch(() => ({}))

    if (!response.ok || !data.url) {
      const message = data.error?.message || data.message || (typeof data.error === "string" ? data.error : null)
      throw new Error(message || DEFAULT_ERROR())
    }

    navigate(data.url)
    return true
  } catch (error) {
    onError(error.message || DEFAULT_ERROR())
    return false
  }
}
